import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/login'
import infoManage from '@/infoManage/index'
import InfoList from '@/infoManage/infoList'
import teacherInfo from '@/infoManage/teacherInfo'
import Tongji from '@/infoManage/tongji'
import UserManage from '@/userManage/index'
import menus from '@/menus/menus'
import menuOrders from '@/menuOrders/menuOrders'
import mealOrderDetail from '@/mealOrderDetail/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/infoManage',
      name: 'infoManage',
      component: infoManage
    },
    {
      path: '/infoList',
      name: 'InfoList',
      component: InfoList
    },
    {
      path: '/teacherInfo',
      name: 'TeacherInfo',
      component: teacherInfo
    },
    {
      path: '/tongji',
      name: 'Tongji',
      component: Tongji
    },
    {
      path: '/userManage',
      name: 'UserManage',
      component: UserManage
    },

    {
      path: '/menus',
      name: 'menus',
      component: menus
    },
    {
      path: '/menuOrders',
      name: 'menuOrders',
      component: menuOrders
    },
    {
      path: '/mealOrderDetail',
      name: 'mealOrderDetail',
      component: mealOrderDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js